export default {
    init() {
        const revealer = document.querySelectorAll('[data-revealer]');

        revealer.forEach(reveal => {
            const content = reveal.querySelector('[data-revealer-content]');
            const element = reveal.querySelector('[data-revealer-element]');
            const cover = reveal.querySelector('[data-revealer-cover]');
            const delay = reveal.getAttribute('data-revealer');

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: reveal,
                    toggleActions: 'play none play none',
                    once: false
                },
                delay: delay
            });

            tl.fromTo(
                element,
                {
                    x: '-104%'
                },
                {
                    x: '0',
                    duration: 0.5,
                    ease: 'circ.inOut'
                }
            );

            if (content) {
                tl.set(content, {
                    opacity: 100
                });
            }

            if (cover) {
                tl.set(cover, {
                    opacity: 0
                });
            }

            tl.to(element, {
                x: '104%',
                duration: 0.5,
                ease: 'circ.inOut'
            });
        });
    }
};
